export default __webpack_public_path__ + "static/media/blog-img92.d341233f.jpg";